export const LIST_EDITED_IMAGES_SUCCESS = 'LIST_EDITED_IMAGES_SUCCESS';
export const GET_IMAGE_SUCCESS = 'GET_IMAGE_SUCCESS';
export const GET_NEW_IMAGE_SUCCESS = 'GET_NEW_IMAGE_SUCCESS';
export const SAVE_COMMENT_SUCCESS = 'SAVE_COMMENT_SUCCESS';
export const SAVE_NEEDS_EDITING_SUCCESS = 'SAVE_NEEDS_EDITING_SUCCESS';
export const LIST_UNEDITED_IMAGES_SUCCESS = 'LIST_UNEDITED_IMAGES_SUCCESS';
export const GET_IMAGE_PROCESSING_INFO_SUCCESS = 'GET_IMAGE_PROCESSING_INFO_SUCCESS';
export const UPDATE_IMAGE_PROCESSING_COMMENT_SUCCESS = 'UPDATE_IMAGE_PROCESSING_COMMENT_SUCCESS';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCES';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCES';
export const SWAP_CATEGORIES_SUCCESS = 'SWAP_CATEGORIES_SUCCESS';
export const UPDATE_IMAGES_CATEGORY_SUCCESS = 'UPDATE_IMAGES_CATEGORY_SUCCESS';
export const DELETE_MULTIPLE_SUCCESS = 'DELETE_MULTIPLE_SUCCESS';
export const UPDATE_IMAGE_FILENAME_SUCCESS = 'UPDATE_FILENAME_SUCCESS';
export const GET_PHOTO_STATUS_SUCCESS = 'GET_PHOTO_STATUS_SUCCESS';
export const GET_SAVE_IMAGE_AS_FAVORITE_SUCCESS = 'GET_SAVE_IMAGE_AS_FAVORITE_SUCCESS';
export const RESET_IMAGE_AS_FAVORITE_SUCCESS = 'RESET_IMAGE_AS_FAVORITE_SUCCESS';
export const DONE_EDITING_IMAGES_SUCCESS = 'DONE_EDITING_IMAGES_SUCCESS';
export const GET_DELIVERY_STATUS_FOR_ORDER_SUCCESS = 'GET_DELIVERY_STATUS_FOR_ORDER_SUCCESS';
export const CREATE_DELIVERY_SUCCESS = 'CREATE_DELIVERY_SUCCESS';
export const CREATE_REDELIVERY_SUCCESS = 'CREATE_REDELIVERY_SUCCESS';
export const SCHEDULED_DELIVERY_OVERRIDDEN = 'SCHEDULED_DELIVERY_OVERRIDDEN';
export const UPDATE_DELIVERY_SUCCESS = 'UPDATE_DELIVERY_SUCCESS';
export const CUSTOMER_APPROVE_SUCCESS = 'CUSTOMER_APPROVE_SUCCESS';
export const CUSTOMER_REAPPROVE_SUCCESS = 'CUSTOMER_REAPPROVE_SUCCESS';
export const COMMIT_LOCAL_SWAP_IMAGES_CATEGORY = 'COMMIT_LOCAL_SWAP_IMAGES_CATEGORY';
export const REDELIVER_IMAGES_SUCCESS = 'REDELIVER_IMAGES_SUCCESS';
export const GET_IMAGE_GALLERY_REFERENCE_SUCCESS = 'GET_IMAGE_GALLERY_REFERENCE_SUCCESS';
export const GET_CONTENT_PROVIDER_SUCCESS = 'GET_CONTENT_PROVIDER_SUCCESS';
export const CREATE_STITCHED_IMAGE_SUCCESS = 'CREATE_STITCHED_IMAGE_SUCCESS';
export const DELETE_UNEDITED_PHOTO_SUCCESS = 'DELETE_UNEDITED_PHOTO_SUCCESS';
export const DELETE_FAILED_PHOTO_SUCCESS = 'DELETE_FAILED_PHOTO_SUCCESS';
export const PHOTOGRAPHER_APPROVED_PHOTO_ORDER_SUCCESS =
    'PHOTOGRAPHER_APPROVED_PHOTO_ORDER_SUCCESS';
export const CLEAR_IMAGEPROCESSING_STATE = 'CLEAR_IMAGEPROCESSING_STATE';
export const SET_IMAGE_PROCESSING_ORDER = 'SET_IMAGE_PROCESSING_ORDER';
export const DELETE_EDITED_PHOTO_SUCCESS = 'DELETE_EDITED_PHOTO_SUCCESS';
export const GET_VITEC_BROKER_SYSTEM_DELIVERY_INFO_SUCCESS =
    'GET_VITEC_BROKER_SYSTEM_DELIVERY_INFO_SUCCESS';
export const RETURN_MULTIPLE_IMAGES_SUCCESS = 'RETURN_MULTIPLE_IMAGES_SUCCESS';
export const RESET_REJECTION_SUCCESS = 'RESET_REJECTION_SUCCESS';

export const COMMIT_LOCAL_CATEGORY_CHANGE_IMAGE = 'COMMIT_LOCAL_CATEGORY_CHANGE_IMAGE';
export const UPDATE_IMAGES_SORT_ORDER_INDEXES = 'UPDATE_IMAGES_SORT_ORDER_INDEXES';